import * as Sentry from "@sentry/vue"
import { createPinia } from "pinia"
import { createPersistedState } from "pinia-plugin-persistedstate"
import { createApp } from "vue"
// import VueScan from "z-vue-scan"
import App from "@/App.vue"
import i18n from "@/lang"
import router from "@/router"
import { dFormat } from "./utils/dayjs"
import "virtual:icons-jm-register"
// import "virtual:icons-autoloader"
import "temporal-polyfill/global"
import "@/assets/scss/index.scss"
import "./tailwind.css"

const meta = document.createElement("meta")
meta.name = "naive-ui-style"
document.head.appendChild(meta)

const pinia = createPinia()
pinia.use(
	createPersistedState({
		key: id => `__persisted__${id}`
	})
)

const app = createApp(App)

if (__APP_ENV__ !== "development") {
	Sentry.init({
		app,
		dsn: "https://1082240230be2558248b7ce0db6d614e@o4508835063988224.ingest.de.sentry.io/4508835066544208",
		environment: __APP_ENV__,
		release: `justmum-frontend@${__APP_VERSION__}`,
		integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
		// Tracing
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: [
			"localhost",
			/^https:\/\/api\.justmum\.xyz/,
			/^https:\/\/api\.justmum\.com/,
			/^https:\/\/api\.justmum\.it/
		],
		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	})
}

app.use(pinia)
app.use(i18n)
app.use(router)
// app.use(VueScan, {})

app.config.globalProperties.$date = dFormat

app.mount("#app")

// TODO-NEXT: rimuovere tutti i n-buttons e sostituirli con JMButton.
// TODO-NEXT: rimuovere tutti i n-card/n-spin e sostituirli con Card
// TODO-NEXT: rinominare JMButton in AppButton
